export var codes = {
  RETCODE: {
    NORMAL: '0000',
    ERROR: '0001',
    ERROR_ARGUMENT: '0002',
    ERROR_THRESH: '0003',

    ERROR_COMMUNICATION: '0101',

    ERROR_NO_INPUT: '0201',
    ERROR_TOKEN: '0300',

  }
};

export class USERCODE {
  IFOCUS : {
    ID: 1,
    NAME: "ifocus"
  }
};
